/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Earningspaidoutsofar4Inputs */

const en_earningspaidoutsofar4 = /** @type {(inputs: Earningspaidoutsofar4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} paid out so far`)
};

const de_earningspaidoutsofar4 = /** @type {(inputs: Earningspaidoutsofar4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} schon ausgezahlt`)
};

/**
* | output |
* | --- |
* | "{amount} paid out so far" |
*
* @param {Earningspaidoutsofar4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningspaidoutsofar4 = /** @type {((inputs: Earningspaidoutsofar4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningspaidoutsofar4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningspaidoutsofar4(inputs)
	return de_earningspaidoutsofar4(inputs)
});
export { earningspaidoutsofar4 as "earningsPaidOutSoFar" }